import { render, staticRenderFns } from "./feiyongxiangqing.vue?vue&type=template&id=6777143b&scoped=true&"
import script from "./feiyongxiangqing.vue?vue&type=script&lang=js&"
export * from "./feiyongxiangqing.vue?vue&type=script&lang=js&"
import style0 from "./feiyongxiangqing.vue?vue&type=style&index=0&id=6777143b&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6777143b",
  null
  
)

export default component.exports